import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { runtimeConfig } from './runtime-config';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value: number, currency?: string): string {
  const code = currency ?? runtimeConfig.currency;
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: code,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatCompactCurrency(value: number, currency?: string): string {
  const code = currency ?? runtimeConfig.currency;
  const abs = Math.abs(value);
  const sign = value < 0 ? '-' : '';
  const prefix = code === 'COP' ? '$\u00A0' : '';

  if (abs >= 1_000_000_000) {
    return `${sign}${prefix}${(abs / 1_000_000_000).toLocaleString('es-CO', { maximumFractionDigits: 1 })} mil M`;
  }
  if (abs >= 1_000_000) {
    return `${sign}${prefix}${(abs / 1_000_000).toLocaleString('es-CO', { maximumFractionDigits: 1 })} M`;
  }
  return formatCurrency(value, code);
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('es-CO').format(value);
}

export function formatPercent(value: number): string {
  return new Intl.NumberFormat('es-CO', {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 2,
  }).format(value / 100);
}
